import { SearchResult } from 'app/concierge/types';
import { IReferenceData } from 'api/concierge';
import { searchAPI } from 'api/search';
import { openInNewTab } from 'tools/tools';
import { Box, Stack } from '@mui/material';
import DatabaseIcon from 'components/common/icon/DatabaseIcon';
import IconMi from 'components/common/icon/IconMi';
import React, { useMemo } from 'react';
import { ICustomStyles } from 'app/concierge/panel';
import defaultStyles from '../styles';
import { useSelector } from 'react-redux';
import { merge } from 'lodash';

export default function ReferenceResultItem({
    result,
    referencesData,
}: {
    result: SearchResult;
    referencesData: IReferenceData[];
}) {
    const referenceData = referencesData.find((item) => item.external_report_reference_id == result.id);
    const reportingTool = referenceData?.reporting_tool_name || '';
    const name = referenceData?.name || result.name;

    const customStyles = useSelector((state: any) => state.concierge.customStyles) as ICustomStyles;

    const styles = useMemo(() => {
        return merge({}, defaultStyles, { item: customStyles?.activeChatMessageResultItem }) as typeof defaultStyles;
    }, [customStyles]);

    const onClick = () => {
        if (referenceData && referenceData.plugin_connection_profile_id && referenceData.external_report_reference_id) {
            searchAPI
                .buildUrl({
                    profile: referenceData.plugin_connection_profile_id,
                    ext_report: referenceData.external_report_reference_id,
                })
                .then((response) => {
                    openInNewTab(response.uri);
                });
        } else if (result.url) {
            openInNewTab(result.url);
        }
    };

    return (
        <Stack sx={styles.item} key={result.id}>
            <Stack direction={'row'} spacing={1}>
                <Box>
                    {reportingTool > '' ? (
                        <DatabaseIcon name={reportingTool} />
                    ) : (
                        <IconMi sx={{ fontSize: 16 }} icon={'metric'} />
                    )}
                </Box>
                <Box sx={styles.link} onClick={onClick}>
                    {name}
                </Box>
            </Stack>
        </Stack>
    );
}
